import { render } from "./BasketExpiryWarning.vue?vue&type=template&id=01c1c54c&scoped=true&lang=pug"
import script from "./BasketExpiryWarning.vue?vue&type=script&lang=ts"
export * from "./BasketExpiryWarning.vue?vue&type=script&lang=ts"

import "./BasketExpiryWarning.vue?vue&type=style&index=0&id=01c1c54c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01c1c54c"

export default script